import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../images/Close.svg";

import { Form, Formik, FormikProps } from "formik";

import { useLazyQuery, useMutation } from "@apollo/client";

import { Title } from "../../../../stories/Title/Title";
import {
  empType,
  LicenseTypes,
  Operation,
} from "../../../../utils/Enum.types";
import { LabelProps } from "../../../../utils/types";
import { Label } from "../../../../stories/Label/Label";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../utils/constants";

import { AppContext } from "../../../../context/context";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import {
  handleMUISelectEvent,
  removeMoreSpace,
} from "../../../../utils/UtilFunctions";
import MessageModal from "../../../../customComponents/MessageModal";
import TextArea from "../../../../stories/TextArea/TextArea";
import InputNumber from "../../../common/Input/InputNumber";
import InputHoc from "../../../common/Input/Index";
import { Button } from "../../../../stories/Button/Button";
import { PredefinedDataTypes, UserFormType } from "../../../../utils/formTypes";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { modalOpertaionFlag } from "../Index";
import { userValidation } from "../../../../utils/validationSchema";
import { nodeVar, OrderDirection } from "../../../../utils/commonQueryTypes";
import { Keys } from "../../../../utils/Enum.keys";
import PhoneInput from "react-phone-input-2";
import LoadingModal from "../../../pages/LoadingModal";
import PredefinedAutocomplete from "../../../../customComponents/PredefinedAutocmplete";
import Navbar from "../../../common/layout/Navbar";
import Steps from "../Steps";
import { useNavigate } from "react-router-dom";
import PredefinedSelect from "../../../../customComponents/PredefinedSelect";
import useFormJson from "../../../../json/useFormJson";
import EmpTypeSelect from "../../../../customComponents/EmpTypeSelect";
import EmplayeeSelect from "../../../../customComponents/EmplayeeSelect";
import {
  AddEmpMasterResult,
  AddEmpMasterVar,
  EmpMaster,
  EmpMasterOrderField,
  EmpQueryType,
  UpdateEmpMasterResult,
  UpdateEmpMasterVar,
} from "../../asset/users/queries/types";
import {
  AddEmpMaster,
  UpdateEmpMaster,
} from "../../asset/users/queries/mutations";
import {
  GetEmp,
  GetEmpMasterByNodeId,
} from "../../asset/users/queries/queries";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<modalOpertaionFlag>>;
  operation: Operation;
  steps: boolean;
}

const AddUsers = ({ setModalFlag, operation, steps }: Props) => {
  const [message, setMessage] = useState(emptyMessage);

  const { state } = useContext(AppContext);
  const navigate = useNavigate();
  const { userFormLabels } = useFormJson();

  const { customer_id } = useUrlParams();
  const emptyFormData: UserFormType = {
    address: "",
    email: "",
    name: "",
    designation: "",
    mobile: "",
    pin: "",
    place: "",
    state: "",
    empType: "",
    companyID: 0,
    kgid: 0,
    metalNo: 0,
    siteID: 0,
    subsidiaryID: 0,
  };
  const [formData, setFormData] = useState<UserFormType>(emptyFormData);
  const { user_details } = useLoggedInUserDetails();

  const [GetEmpById, { data, loading: GetEmpMasterByNodeIdLoading }] =
    useLazyQuery<{ node: EmpMaster }, nodeVar>(GetEmpMasterByNodeId);

  const [AddEmpDetails, { loading: AddEmpMasterLoading }] = useMutation<
    AddEmpMasterResult,
    AddEmpMasterVar
  >(AddEmpMaster, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateEmpDetails, { loading: UpdateEmpMasterLoading }] = useMutation<
    UpdateEmpMasterResult,
    UpdateEmpMasterVar
  >(UpdateEmpMaster, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<UserFormType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleSubmit = async () => {
    if (operation === Operation.CREATE) {
      if (state.customerId || customer_id) {
        const empAdded = AddEmpDetails({
          variables: {
            user_details,
            input: {
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              email: formData.email,
              mobile:
                formData.mobile.length === 12
                  ? `+${formData.mobile}`
                  : EMPTY_STRING,
              pin: formData.pin,
              state: formData.state,
              name: removeMoreSpace(formData.name),
              empType: empType.SYS_ADMIN ,
              companyID: 0,
              subsidiaryID: 0,
              siteID: 0,
              kgid: 0,
              metalNo: 0,
            },
            customer_id: customer_id ? customer_id : state.customerId,
          },
          refetchQueries: [
            {
              query: GetEmp,
              variables: {
                after: null,
                customer_id: customer_id ? customer_id : state.customerId,
                first: ROWS_PER_PAGE,
                input: {
                  queryType: EmpQueryType.ALL,
                  empType: [empType.DCP],
                  companyID: 0,
                  ldgrID: 0,
                  siteID: 0,
                  subsidiaryID: 0,
                },
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: EmpMasterOrderField.NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddEmpMaster) {
          setMessage({
            flag: true,
            message: "Employee added successfully",
            operation: Operation.CREATE,
          });
        }
      }
    } else {
      const customerUpdated = UpdateEmpDetails({
        variables: {
          user_details,
          customer_id: customer_id ? customer_id : state.customerId,
          emp_id: state.empId,
          input: {
            address: removeMoreSpace(formData.address),
            place: removeMoreSpace(formData.place),
            email: formData.email,
            mobile:
              formData.mobile.length === 12
                ? `+${formData.mobile}`
                : EMPTY_STRING,
            pin: formData.pin,
            state: formData.state,
            name: removeMoreSpace(formData.name),
            empType: formData.empType as empType,
            companyID: formData.companyID,
            subsidiaryID: formData.subsidiaryID,
            siteID: formData.siteID,
            kgid: Number(formData.kgid),
            metalNo: Number(formData.metalNo),
          },
        },
        refetchQueries: [
          {
            query: GetEmp,
            variables: {
              after: null,
              customer_id: customer_id ? customer_id : state.customerId,
              input: {
                queryType: EmpQueryType.ALL,
                empType: [empType.DCP],
                companyID: 0,
                ldgrID: 0,
                siteID: 0,
                subsidiaryID: 0,
              },
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME,
              },

              name: EMPTY_STRING,
            },
          },
        ],
      });
      const { data } = await customerUpdated;

      if (data && data.UpdateEmpMaster) {
        setMessage({
          flag: true,
          message: "Employee details updated successfully",
          operation: Operation.CREATE,
        });
      }
    }
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(emptyFormData);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      if (message.operation === Operation.CREATE && steps) {
        navigate(`/`);
      }
      setModalFlag({
        flag: false,
        operation: Operation.CREATE,
      });
    }
  };

  useEffect(() => {
    if (operation === Operation.UPDATE) {
      GetEmpById({
        variables: {
          id: state.empId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            address: data.node.address,
            email: data.node.email,
            name: data.node.name,
            designation: data.node.empType,
            mobile: data.node.mobile.replace("+", ""),
            pin: data.node.pin,
            place: data.node.place,
            state: data.node.state,
            empType: data.node.empType,
            companyID: data.node.companyID,
            kgid: data.node.kgid,
            metalNo: data.node.metalNo,
            siteID: data.node.siteID,
            subsidiaryID: data.node.subsidiaryID,
          });
        }
      });
    }
  }, [operation, GetEmpById, state.empId, data]);

  const handleNumberChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleAutcompleteChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      {operation === Operation.CREATE && (
        <>
          {steps && <Navbar NavType={LicenseTypes.CUSTOMER} />}
          <Title>Add User</Title>
        </>
      )}
      {steps && <Steps step={4} />}

      {operation === Operation.UPDATE && (
        <div className="cust_users__add--title">
          <Title>Update User</Title>
          <img
            src={Close}
            alt=""
            onClick={() => {
              hanldeClear();
              setModalFlag({
                flag: false,
                operation: Operation.CREATE,
              });
            }}
          />
        </div>
      )}

      <Formik
        initialValues={formData}
        validationSchema={userValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <div className={steps ? `customer` : `customer__add`}>
              <Form className={`customer__add--${steps ? "form" : "edit"}`}>
                <div className="customer__add--form-head">
                  <h4>User Details</h4>
                </div>
                <div className="customer__add--form-details row g-0">
                  <div className="col h-100">
                    {userFormLabels.leftForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <TextArea
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                rows={3}
                                name={field.inputName}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                country={"in"}
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                onKeyDown={(e: {
                                  key: Keys;
                                  preventDefault: () => void;
                                }) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                                name={field.inputName}
                                required={field.required}
                                maxLength={field.maxLength}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.inputName === "mobile") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                inputProps={{
                                  required: true,
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                            </div>
                          );
                        } else if (field.inputName === "empType") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <EmpTypeSelect                           
                                onChange={(newValue) => {
                                  setFormData({
                                    ...formData,
                                    empType: newValue as string,
                                  });
                                }}
                                value={formData.empType}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="col h-100">
                    {userFormLabels.rightForm.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "textarea") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <TextArea
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLTextAreaElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                type={field.dataType}
                                rows={3}
                                required={field.required}
                                name={field.inputName}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                                inputProps={{
                                  required: true,
                                }}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <InputNumber
                                value={formData[field.inputName]}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                name={field.inputName}
                                required={field.required}
                                maxLength={field.maxLength}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "empType") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <EmpTypeSelect
                                onChange={(newValue) => {
                                  setFormData({
                                    ...formData,
                                    empType: newValue,
                                  });
                                }}
                                value={formData.empType}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                              />
                              {meta.touched && meta.errors[field.inputName] ? (
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                </div>

                <Button mode="save" type="submit" />
                <Button mode="clear" type="reset" onClick={hanldeClear} />
                {steps ? (
                  <Button
                    mode="back"
                    type="button"
                    onClick={() => navigate(-1)}
                  />
                ) : (
                  <Button
                    mode="cancel"
                    type="button"
                    onClick={() =>
                      setModalFlag({
                        flag: false,
                        operation: Operation.CREATE,
                      })
                    }
                  />
                )}
              </Form>
            </div>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetEmpMasterByNodeIdLoading ||
          AddEmpMasterLoading ||
          UpdateEmpMasterLoading
        }
      />
    </>
  );
};

export default AddUsers;
